import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';

const FALLBACK_KEY = '/';

const setMetaDescription = (value) => {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const SeoManager = () => {
  const { pathname } = useLocation();
  const { content } = useI18n();

  useEffect(() => {
    const seoMap = (content && content.seo) || {};
    const entry = seoMap[pathname] || seoMap[FALLBACK_KEY];
    if (!entry) return;
    document.title = entry.title;
    setMetaDescription(entry.description);
  }, [pathname, content]);

  return null;
};

export default SeoManager;
